import React, { useState } from "react";
import { ModalComponent } from "../../../../components/Modal.components";
import { Boxed } from "../../../../components/Boxed.components";
import { Text } from "../../../../components/Text.components";
import { Button } from "../../../../components/Button.components";
import { PageTitle } from "../../../../components/style";

export const CompanySwitch = (props) => {
  // State props
  const { switchModal, organizations } = props;
  // Dispatch props

  const { closeModal, switchOrganizations } = props;
  const [active, setActive] = useState({});

  console.log({active, organizations});
  return (
    <ModalComponent
      show={switchModal}
      onHide={closeModal}
      title={<PageTitle margin="5px 0">Switch Organizations</PageTitle>}
      footer={
        <Boxed display="flex" width="100%">
          <Button clear onClick={closeModal}>
            Cancel
          </Button>
          <Button
            margin="0 0 0 auto"
            onClick={() => {
              switchOrganizations(active)
              window.location.reload()
            }}
          >
            Switch
          </Button>
        </Boxed>
      }
    >
      <Text>Please select the organisation you wish to sign into.</Text>

      <Boxed flexDirection="column" display="flex" pad="15px">
        {organizations.map((org) => (
          <Boxed
            key={org._id}
            display="flex"
            alignItems="center"
            pad="3px"
            cursor="pointer"
            style={{
              border: `${
                active?._id === org._id ? "2px solid #28282B" : ""
              }`,
              borderWidth: `${active?._id === org._id ? '2px': "0"}`,
            }}
            onClick={() => setActive(org)}
          >
            <img
              src={org?.companyLogoUrl}
              alt={org?.name}
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "9999px",
                margin: "0 5px",
                border: '1px solid #ccc'
              }}
            />
            <Text>{org?.name}</Text>
          </Boxed>
        ))}
      </Boxed>
    </ModalComponent>
  );
};
